import { ChannelPerformanceBand } from '@/components/channel/ChannelPerformanceBand';

export function ChannelAnalyticsPage() {
  return (
    <main className="p-4 sm:p-8 font-jakarta overflow-x-hidden">
      <ChannelPerformanceBand />
    </main>
  );
}
